import { FinishedRequestDTO } from "@/types/scheduling";
import { RequestSchedulingResponse } from "@/types/scheduling";
import { httpRequest } from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

async function finishedScheduling(
  request: FinishedRequestDTO
): Promise<RequestSchedulingResponse> {
  const { id, ...data } = request;
  const response = await httpRequest.post<RequestSchedulingResponse>(
    `schedulings/finished/${id}`,
    data
  );
  return response.data;
}

export function useFinishedSchedulingMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: finishedScheduling,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schedulings"] });
    },
  });
}
